<script lang="ts" setup>
withDefaults(
  defineProps<{
    text: string
    icon?: string | null
  }>(),
{ icon: null }
)
</script>

<template>
  <div class="border-4 border-transparent">
    <div class="flex items-center justify-center rounded-xl border border-[#EFEFEF] px-2 py-1.5">
      <span class="text-xs leading-[1.33] md:text-sm" :class="{'pr-1.5': icon}">
        {{ text }}
      </span>

      <SvgIcon v-if="icon" :name="icon" />
    </div>
  </div>
</template>
